export default __webpack_public_path__ + "static/rene_well_water-d89367b6626a2e5a115f976a7eb1c230.jpg";